import {Component, Input, OnInit} from '@angular/core';
import {Router} from "@angular/router";
import {ModalController} from "@ionic/angular";

@Component({
  selector: 'app-header-toolbar-empty',
  templateUrl: './header-toolbar-empty.component.html',
  styleUrls: ['./header-toolbar-empty.component.scss'],
})
export class HeaderToolbarEmptyComponent implements OnInit {

  @Input() title:string;
  @Input() backUrl: string;
  constructor(private route: Router, private modalController: ModalController) {}
  ngOnInit() {}

}
